module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("What They Didn’t Teach You in Spanish Class")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "aabk",
      "title": "Using This Book"
    }
  }, [_c('p', {
    staticClass: "h2f1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#abk"
    }
  }, [_c('b', [_vm._v("Using This Book")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("This book was written with the assumption that you already took a fair number of adequate Spanish classes, and already know how to speak the language itself, at least in its abstract, off-the-rack form. This is a book designed to take your Spanish to the next level, out into the real world, and cannot be as precise or definitive as a language textbook because it is a pile of examples to help you figure out always-contextual and ever-changing slang. So if you’re looking for a grammar lesson or a universal phrase book, you’re in the wrong spot. But if you want to tell your friend that he has a tiny dick or to get rid of the douchebag hitting on you in the bar, this is the book for you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every phrase in this book is in current usage, and most of it isn’t in dictionaries even though it’s widely used and understood. Except in special cases, the English is given first, followed by the Spanish. Sometimes the Spanish is given with alternatives ("), _c('i', [_vm._v("gordo/a, tu/s")]), _vm._v(") to account for gender or plural differences. This isn’t a grammar book and you’re not an idiot, so we expect that you’ll be able to figure it out without any more explanation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unlike other volumes in the "), _c('i', [_vm._v("What They Didn’t Teach You In Class")]), _vm._v(" series, this book covers not one language, but many. That’s because Spanish is not universal. The slang and casual language you’ll hear in Colombia is quite different from what you might hear in Spain or Mexico. Most of what’s included here was chosen because it’s easily understood in any Spanish-speaking country, but there are many terms that are region- or country-specific. For all of those, we’ve indicated, in parentheses, in which region or country the phrase is most commonly used:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_c('b', [_vm._v("Country")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_c('b', [_vm._v("Abbreviation")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Latin America")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("LatAm")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("South America")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("S.Am")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Central America")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("CenAm")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Southern Cone")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("S.Cone (Argentina, Chile, and Uruguay)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Caribbean")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Carib")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Andes")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Andes")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Mexico")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Mex")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Guatemala")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Gua")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("El Salvador")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("ElS")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Honduras")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Hon")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Nicaragua")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Nic")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Costa Rica")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("CoR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Panama")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Pan")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Cuba")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Cub")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Dominican Republic")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("DoR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Puerto Rico")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("PuR")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Venezuela")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Ven")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Colombia")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Col")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Ecuador")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Ecu")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Peru")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Per")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Bolivia")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Bol")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Chile")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Chi")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_vm._v("Paraguay")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Par")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Uruguay")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Uru")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Argentina")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Arg")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Spain")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tpara"
  }, [_vm._v("Spn")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Whenever a regional term is given in addition to a universal one, you can assume it’ll sound natural to someone from that region to hear that term. However, many regional words are rapidly becoming international, as Latin American media culture continues to globalize, and as teenagers everywhere listen to MP3s and download TV shows from around the Spanish-speaking globe.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If personal curiosity or professional demands require you to know exactly where a given term is used, or if you want to dive deeper into the seedy world of Spanish slang, the easiest place to start is online. Here are some resources:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "http://www.rae.es",
      "target": "_blank"
    }
  }, [_vm._v("www.rae.es")]), _vm._v("—The Real Academia Española’s online dictionary may not always be cutting-edge for Latin American slang, but at least it’s reliable and accurate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "http://www.jergasdehablahispana.org",
      "target": "_blank"
    }
  }, [_vm._v("www.jergasdehablahispana.org")]), _vm._v("—Roxana Fitch’s invaluable, free, and searchable dictionary houses a massive collection of slang, sorted by region.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "http://forum.wordreference.com",
      "target": "_blank"
    }
  }, [_vm._v("forum.wordreference.com")]), _vm._v("—The Word Reference forums are a thriving international community of professional translators and amateur linguists, where you can get answers from real people in the field.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The best language teacher, however, will always be immersion. So get to traveling, do some downloading, start YouTubeing, or, at the very least, go to the Hispanic part of town and strike up some conversations—just don’t start with what you learned in the Smack Talk chapter!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now plow through this quickly as a starting point and get out there and get creative—real Spanish isn’t in a book, it’s on the lips of the drunk people, scrawled on bathroom walls, and muttered in your ear by the guy next to you in the back of cop car.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Pronouncing Spanish")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("Speaking Spanish like a "), _c('i', [_vm._v("pinche gringo")]), _vm._v(" will make you seem like, well, a "), _c('i', [_vm._v("pinche gringo,")]), _vm._v(" and will raise the price of everything you want to buy in proportion to how annoying your accent is. It can even mark you as an easy target for pickpockets or muggers. So get your pronunciation straight. You have three golden rules to remember:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. Watch your damn vowels already! Each vowel is essentially the same in every context:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("A")]), _vm._v(" is always like the “a” in “father.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("O")]), _vm._v(" is always like the “o” in “bone.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("I")]), _vm._v(" is always like the “ie” in “wiener.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("E")]), _vm._v(" is always like the “e” in “wet.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("U")]), _vm._v(" is always like the “oo” in “poon,” unless it comes after a “g” or a “q” and has no umlaut dots over it, in which case it’s silent.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One of the biggest slipups that English speakers make when speaking Spanish is following the unconscious English pronunciation rules that make vowels change contextually, smuggling in foreign A’s and turning every unstressed vowel into the “uuuuh” sound that Spanish speakers equate with the pronunciation of a village idiot (don’t pruhtend you don’t know whuht I’m talking uhbout).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2. Most consonants are the same as English, but a few can really trip you up. G’s are pronounced like an English G before A, U, Ü, or O, but before E and I, they sound more like an English H (so does an X, by the way). J’s are like English H’s but pushed further back in the throat, which you may notice people clearing their throats or some native speakers of Hebrew or Arabic doing in English. H’s are always silent, and if you pronounce them, it’s a dead giveaway that you’re just starting out, and will often get you “Oh, honey” looks. D’s and R’s before vowels are hard to pronounce quickly and lightly enough. K’s, hard C’s, T’s, and P’s aren’t aspirated as they are in English (aspiration is that puff of air you feel if you hold your hand "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  }, [_vm._v("in front of your mouth and pronounce “pop” and “totally” in any North American accent). If your teachers taught you to pronounce your Z’s as TH’s in Spanish and you’re anywhere outside of Spain, stop that right away; it’s not going to go well for you. Pay attention to local LL pronunciation, because it varies wildly not just by geography but also by context (between casual speech and singing, for instance). Similarly, how hard people roll their RRs (and whether they roll Rs at the beginning of words for clarity and emphasis) varies too much for general rules to be helpful.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3. Pay attention to accents when learning new words, and review the accent rules online or in your old grammar book before traveling. If you put the accent on the wrong syllable, people think you’re saying another word, which, 99 percent of the time, will be a word that doesn’t exist. Americans are often shocked by not being understood for having fudged such a “minor” detail. But it makes a major difference to Spanish speakers, so they, in turn, feel shocked when Americans walk around speaking gibberish and getting impatient with people.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("4. Don’t overpronounce. Pay attention to local pronunciation and try to keep up; it makes you sound natural and cool. Vowels and syllables sometimes drop out of the middle of long words ("), _c('i', [_vm._v("no te pr’ocupes")]), _vm._v("). D’s between vowels at the end of words often drop out to make a vowel diphthong (it’s "), _c('i', [_vm._v("complicao")]), _vm._v("). Consonants at the end of words in an unstressed syllable, particularly D’s and S’s, often get underpronounced or forgotten altogether ("), _c('i', [_vm._v("de vera’, no te procupa’")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the Caribbean, this process is taken one step further, frequently coming right in the middle of a word ("), _c('i', [_vm._v("¡Tú huele’ com’u’ pe’cao!")]), _vm._v("). Also, syllable emphasis can change from city to city, overriding the normal accent-placement of a word. Similarly, subtle slipups like mixing up the pronunciation between S and Z or T and D, however the word might actually be spelled, can mark you as foreign. So listen closely to how people pronounce words you thought you already knew.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39bfbca9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Book.vue
// module id = 72
// module chunks = 0